import Box from '@mui/material/Box'
import Typography from '@mui/material/Typography'
import { Link } from '@mui/material';

function DailyCreditUsageNotifications() {
    return (<Box>
        <Typography>
            IPDetective now supports daily credit usage notifications for signed-in users.
            When enabled, IPDetective will send an email when daily usage reaches 90% and one more email when the daily limit is fully used.
        </Typography>
        <br/>
        <Typography variant='h4'>
            What changed
        </Typography>
        <Typography>
            The Account dashboard now includes a Notifications section with a toggle for daily credit usage emails.
            The setting is enabled by default so users get warning before running out of daily API credits.
        </Typography>
        <br/>
        <Typography variant='h4'>
            How the alert works
        </Typography>
        <Typography>
            IPDetective checks usage after authenticated IP lookups that consume credits.
            The first alert is sent when request or lookup usage reaches 90% of the daily limit.
            A second alert can be sent when the account reaches 100% usage for the day.
        </Typography>
        <br/>
        <Typography>
            To avoid duplicate messages, each alert is sent at most once per daily reset.
            Users who do not want these emails can opt out from the <Link href="/account">Account dashboard</Link>.
        </Typography>
        <br/>
        <Typography variant='h4'>
            Why it matters
        </Typography>
        <Typography>
            Usage alerts make it easier to notice unexpected API traffic, plan around higher-volume days, and upgrade before critical workflows run out of credits.
        </Typography>
    </Box>)
}

export default DailyCreditUsageNotifications
